const t = "text_7tRRX", e = {
  text: t
};
export {
  e as default,
  t as text
};
//# sourceMappingURL=rotativeText.module.scss.js.map
